
  
  <div mat-dialog-content class="message-container">
    <p>{{data.message }}</p>
  </div>
  
  <div mat-dialog-actions class="mdc-action-container">
    <button mat-raised-button color="primary" (click)="onClose()">Ok</button>
  </div>